import axios from "axios";
import { getApiDomain } from "./serviceConfig";

const apiDomain = getApiDomain();
const defaultConfig = {
    headers: { "Content-type": "application/json" },
};

const axiosManager = {
    axiosInstance: axios.create({
        baseURL: apiDomain,
        headers: {
            "Access-Control-Allow-Origin": "*",
            ...defaultConfig.headers,
        },
    }),

    setAuthToken(token) {
        this.axiosInstance.interceptors.request.use(
            (config) => {
                if (config.headers && token) {
                    // eslint-disable-next-line no-param-reassign
                    config.headers.Authorization = config.headers.Authorization || token;
                }

                return config;
            },
            (error) => Promise.reject(error),
        );
    },

    removeAuthToken() {
        this.axiosInstance.interceptors.request.use(
            (config) => {
                if (config.headers) {
                    // eslint-disable-next-line no-param-reassign
                    config.headers.Authorization = undefined;
                }

                return config;
            },
            (error) => Promise.reject(error),
        );
    },

    request$(url, method, data, config) {
        return new Promise((resolve, reject) => {
            const configMerged = {
                ...defaultConfig,
                ...config,
                headers: { ...defaultConfig.headers, ...(config?.headers || {}) },
            };

            this.axiosInstance.request({
                ...configMerged,
                url,
                method,
                data,
            })
                .then(resolve)
                .catch(reject);
        });
    },

    get$(url, config) {
        return this.request$(url, "get", null, config);
    },

    post$(url, args, config) {
        return this.request$(url, "post", args, config);
    },

    put$(url, args, config) {
        return this.request$(url, "put", args, config);
    },

    patch$(url, args, config) {
        return this.request$(url, "patch", args, config);
    },

    head$(url) {
        return this.request$(url, "head");
    },

    delete$(url) {
        return this.request$(url, "delete");
    },
};

export default axiosManager;
